module.exports = __webpack_public_path__ + "img/dk.527602ba.svg";